import EatOut from "./EatOut.js";

export default EatOut;
